import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

const ChartCard = ({ id, title, icon, headerColor, darkMode, children }) => {
  return (
    <Card id={id} className="mb-3 shadow-sm h-100" style={{ border: 'none', borderRadius: '8px', overflow: 'hidden' }}>
      <Card.Header
        style={{
          backgroundColor: headerColor,
          color: '#fff',
          fontWeight: 600,
          fontSize: '0.95rem',
          padding: '10px 16px',
          border: 'none',
        }}
      >
        <i className={`${icon} me-2`} />
        {title}
      </Card.Header>
      <Card.Body
        className="d-flex flex-column"
        style={{ backgroundColor: darkMode ? '#2b2b2b' : '#fff', padding: '12px', flex: 1 }}
      >
        <div style={{ flex: 1, minHeight: 0 }}>{children}</div>
      </Card.Body>
    </Card>
  );
};

ChartCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  headerColor: PropTypes.string.isRequired,
  darkMode: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default ChartCard;
